import React from "react";
import {
	Input,
	InputCountriesGroup,
	InputFuelGroup,
	InputVehicleGroup,
	Sensors,
} from "../../Helpers/Input/Input";
import FuelSupport from "./FuelSupport/FuelSupport";
import trans from "../../../utils";
import { useSelector } from "react-redux";

export default function VehicleInfo({ addData }) {
	const inf = useSelector((state) => state.users.user);
	return (
		<div className="vehicleinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("vehicle info")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("Vehicle name")}
						type="text"
						placeholder={trans("Name")}
						id="name"
						name="name"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.name}
						touched={addData.touched.name}
						value={addData.values.name || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("plate number")}
						type="text"
						placeholder={trans("License plate")}
						id="plateNumber"
						name="plateNumber"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.plateNumber}
						touched={addData.touched.plateNumber}
						value={addData.values.plateNumber || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title="VIN"
						type="text"
						placeholder="VIN"
						id="vin"
						name="vin"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						value={addData.values.vin || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Code")}
						type="text"
						placeholder={trans("Code")}
						id="code"
						name="code"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						value={addData.values.code || ""}
						errors={addData.errors.code}
						touched={addData.touched.code}
					/>
				</div>
				<div className="col-lg-6">
					<InputVehicleGroup
						id="vehicleType"
						name="vehicleType"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.setFieldValue}
						errors={addData.errors.vehicleType}
						touched={addData.touched.vehicleType}
						value={addData.values.vehicleType || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Registration number")}
						type="text"
						placeholder={trans("Registration number")}
						id="registrationNumber"
						name="registrationNumber"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.registrationNumber}
						touched={addData.touched.registrationNumber}
						value={addData.values.registrationNumber || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Model")}
						type="text"
						placeholder={trans("Model")}
						id="model"
						name="model"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.model}
						touched={addData.touched.model}
						value={addData.values.model || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Brand")}
						type="text"
						placeholder={trans("Vehicle Brand")}
						id="brand"
						name="brand"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.brand}
						touched={addData.touched.brand}
						value={addData.values.brand || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("color")}
						type="text"
						id="color"
						name="color"
						placeholder={trans("Vehicle Color")}
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.color}
						touched={addData.touched.color}
						value={addData.values.color || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Year")}
						type="text"
						id="year"
						name="year"
						placeholder={trans("Year")}
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.year}
						touched={addData.touched.year}
						value={addData.values.year || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputCountriesGroup
						id="make"
						name="make"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.setFieldValue}
						value={addData.values.make || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputFuelGroup
						id="fuelType"
						name="fuelType"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.setFieldValue}
						value={addData.values.fuelType || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={`${trans("Fuel Consumption")} (${
							inf.attributes.volumeUnit
								? trans(inf.attributes.volumeUnit)
								: trans("ltr")
						})`}
						type="text"
						placeholder={`${trans(inf?.attributes.volumeUnit)}${trans(
							"/100"
						)} ${trans(inf?.attributes.distanceUnit || "km")}`}
						id="fuelConsumption"
						name="fuelConsumption"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.fuelConsumption}
						touched={addData.touched.fuelConsumption}
						value={addData.values.fuelConsumption || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Fuel Price")}
						type="text"
						placeholder={trans("0.0 AED")}
						id="fuelCost"
						name="fuelCost"
						formstyle="form-input"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.fuelCost}
						touched={addData.touched.fuelCost}
						value={addData.values.fuelCost || ""}
					/>
				</div>
			</div>

			<div className="w-50">
				<Sensors
					vehicleInf={true}
					title="Fuel"
					id="fuelSupport"
					name="fuelSupport"
					onBlur={addData.handleBlur}
					onChange={addData.handleChange}
					value={addData.values.fuelSupport || ""}
				/>
			</div>
			{addData.values.fuelSupport && <FuelSupport addData={addData} />}
		</div>
	);
}
